module.exports = __webpack_public_path__ + "static/~test_map_big-75271f7aa2f3571cd0f9dbd0017974a0.jpg";